import React, { useCallback, useLayoutEffect, useRef } from "react";
import classnames from "classnames";
import { Option } from "@shared/interfaces";

import "./index.scss";
import { Label } from "../Common";

export interface MultiToggleProps<T> {
  labelTitle?: string;
  labelClassName?: string;
  options: Option<T>[];
  value?: Option<T> | null;
  onChange?: (opt: Option<T>) => void;
  className?: string;
}

export default function MultiToggle<T>(props: MultiToggleProps<T>) {
  const toggleElRef = useRef<HTMLDivElement>(null);
  const toggleOptionBgElRef = useRef<HTMLDivElement>(null);

  const { value: selectedOption, onChange, options, className, labelTitle, labelClassName } = props;

  const handleClickOnOption = useCallback(
    (opt: Option<T>) => {
      onChange && onChange(opt);
    },
    [onChange],
  );

  useLayoutEffect(() => {
    if (!toggleElRef.current || !toggleOptionBgElRef.current) return;

    const activeOptEl = toggleElRef.current.getElementsByClassName("multi-toggle-option_active")[0] as HTMLDivElement;

    if (activeOptEl) {
      toggleOptionBgElRef.current.style.left = `${activeOptEl.offsetLeft}px`;
      toggleOptionBgElRef.current.style.width = `${activeOptEl.offsetWidth}px`;
    }
  }, [selectedOption]);

  return (
    <>
      {labelTitle && <Label title={labelTitle} className={labelClassName} />}
      <div ref={toggleElRef} className={classnames("multi-toggle", className)}>
        <div ref={toggleOptionBgElRef} className="multi-toggle-option-bg" />
        {options.map((opt) => {
          return (
            <span
              key={String(opt.value)}
              className={classnames("multi-toggle-option", {
                "multi-toggle-option_active": selectedOption && selectedOption.value === opt.value,
              })}
              onClick={() => handleClickOnOption(opt)}
            >
              {opt.label}
            </span>
          );
        })}
      </div>
    </>
  );
}
